import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';
import statusLogo from '../../assets/status_logo.png';
import networkDirectory from '../../assets/Status Solutions Network Logo_inline-01.jpg';
import Logo from '../Logo/Logo';
import StatusFooter from '../StatusFooter/StatusFooter';
import logComponent from '../../common/logComponent';
//import { useMsal } from "@azure/msal-react";
//import { loginRequest } from '../../authConfig';

export default function Landing() {
  const navigate = useNavigate();
  //const { instance } = useMsal();

  if (logComponent('Landing')) { console.debug('Landing rendered'); }

  const loginClick = () => {
    if (logComponent('Landing')) { console.debug('Landing loginClick'); }
    sessionStorage.setItem('previousEnvironmentContext', null);
      //instance.loginRedirect(loginRequest);
      navigate("/login");

  }

  return (
    <div className="Landing">
      <div className="Landing__content">
        <div className="Landing__hero">
          <p className="Landing__hero-message">Welcome to MIMI</p>
          <p className="Landing__hero-slogan">Merging Information <span className="Landing__italic">into</span> Meaningful Insights</p>
          <div className="Landing__logo-frame">
            <Logo />
          </div>
        </div>
        <main className="Landing__main">
          <div className="Landing__login">
            <p className="Landing__login-instruction">
              <span>To access the portal,</span>
              <span>begin by signing in here:</span>
            </p>
            <button className="Landing__login-button" onClick={loginClick}>Login</button>

          </div>
          <div className="Landing__info">
            <h2 className="Landing__info-heading">
              <span><span className="Landing__info-heading--bold">MIMI </span> powered by</span>
              <img className="Landing__info-heading-image" alt="Status Solutions" src={statusLogo} />
            </h2>
            <div className="Landing__info-text">
              <p>Ready to Merge Information into Meaningful Insights?  MIMI incorporates the data within the Status Solutions’ situational awareness suite and presents it on an analytics dashboard to provide the right information, to the right people, at the right time. The MIMI dashboard helps analyze relevant information and other data collected over time to enable staff and family members to have access to meaningful insights. MIMI provides a platform for end users and staff to easily interact with one another and understand what’s going on within a given organization, while arming administrators with important information to make impactful decisions.</p>
              <p>MIMI is there to help and so are we, because <span className="bold">RIGHT NOW</span> matters most.</p>
              <a className="Landing__info-link" target="_blank" rel="noopener noreferrer" href="http://www.schoolsolutionsnetwork.com/">
                <img src={networkDirectory} alt="Network Directory" />
              </a>
            </div>
          </div>
        </main>
      </div>
      <footer>

        <StatusFooter />
      </footer>
    </div>
  );
}

